class AuthService {
    static base_url = process.env.REACT_APP_BACKEND_URL + '/api/auth';

    static buildParams(params) {
        return params ? new URLSearchParams(params).toString() : '';
    }

    static async login(credentials, axiosInstance) {
        const response = await axiosInstance.post(`${this.base_url}/login`, credentials);
        return response.data;
    }

    static async socialLogin(credentials, axiosInstance, provider, config = {}) {
        const response = await axiosInstance.post(`${this.base_url}/login/${provider}/callback`, credentials, config);
        return response.data;
    }

    static async me(params, axiosInstance, config = {}) {
        const queryString = this.buildParams(params);
        const response = await axiosInstance.get(`${this.base_url}/me?${queryString}`, config);
        return response.data;
    }

    static async getUserByRememberToken(token, axiosInstance) {
        const response = await axiosInstance.post(`${process.env.REACT_APP_BACKEND_URL}/api/user/by-remember-token`, { token });
        return response.data;
    }

    static async logout(axiosInstance) {
        const response = await axiosInstance.post(`${this.base_url}/logout`);
        return response.data;
    }

    static async passwordResetByToken(data, axiosInstance) {
        const response = await axiosInstance.post(`${process.env.REACT_APP_BACKEND_URL}/api/user/password-reset-by-token`, data);
        return response.data;
    }
}

export default AuthService;
